import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  EntitiesList,
  EntitiesListItem,
} from '../../components/entities-card/EntitiesList';

type Props = {
  enterprise: {
    appellationCommerciale?: string | null;
    cleanSiren?: string | null;
    ville?: string | null;
    secteurActivite?: string | null;
    tailleGlob?: string | null;
    dateRadiation?: string | null;
    [s: string]: any;
  };
};

const displayedDataKeys: { key: string; labelId: string }[] = [
  {
    key: 'appellationCommerciale',
    labelId: 'app.entities.enterprise.card.infos.tradeName',
  },
  {
    key: 'cleanSiren',
    labelId: 'app.entities.enterprise.card.infos.siren',
  },
  {
    key: 'ville',
    labelId: 'app.entities.enterprise.card.infos.city',
  },
  {
    key: 'secteurActivite',
    labelId: 'app.entities.enterprise.card.infos.sector',
  },
  {
    key: 'tailleGlob',
    labelId: 'app.entities.enterprise.card.infos.size',
  },
  {
    key: 'dateRadiation',
    labelId: 'app.entities.enterprise.card.infos.closingDate',
  },
];

export const EnterpriseDetails: FC<Props> = ({ enterprise }) => {
  const removeForbiddenKeys = displayedDataKeys.filter(
    ({ key }) => !!enterprise[key],
  );

  return (
    <EntitiesList>
      {removeForbiddenKeys.map(({ key, labelId }) => (
        <EntitiesListItem
          key={key}
          left={<FormattedMessage id={labelId} />}
          right={enterprise[key]}
        />
      ))}
    </EntitiesList>
  );
};
